import calendarFiltersComponent from './calendarFilters.component';

let calendarFiltersModule = angular.module('vacations-absences.calendarFilters', [])

.component('calendarFilters', calendarFiltersComponent)

.name;

export default calendarFiltersModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarFilters/calendarFilters.js